import { render } from "./cargarArchivo.vue?vue&type=template&id=e83e4012&scoped=true"
import script from "./cargarArchivo.vue?vue&type=script&lang=js"
export * from "./cargarArchivo.vue?vue&type=script&lang=js"

import "./cargarArchivo.vue?vue&type=style&index=0&id=e83e4012&scoped=true&lang=css"
import "./cargarArchivo.vue?vue&type=style&index=1&id=e83e4012&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e83e4012"]])

export default __exports__